exports.default = {
  'team_invite_download_qr': 'Download invitation QR code',
  'team_invite_add_phone': 'Add phone number',
  'invitation_code': 'Invitation Code',
  'enter_invitation_code': 'Please enter invitation code',
  'join_team_applied': 'You have successfully applied to join the team! You will join the team after admin approval',
  'join_team_success': 'You have successfully joined the team!',
  'join_team_invitation': 'Team invitation',
  'join_team_title_fallback': 'Join a team',
  'join_team_invited_by': '{name} invited you to join the team',
  'join_team_invited_default': 'A teammate invited you to join',
  'join_team_visual_note': 'Collaborate with your team and move work forward together in PAITEAMS.',
  'join_team_invalid_title': 'This invitation is no longer valid',
  'join_team_invalid_description': 'It may have expired, been reset, or belong to an unavailable team. Ask the inviter for a new link.',
  'join_team_return_home': 'Return home',
  'join_team_heading': 'Join {team}',
  'join_team_already_member_title': 'You are already on this team',
  'join_team_already_member_description': 'No verification is needed. You can return to {team}.',
  'join_team_back_to_team': 'Back to team',
  'join_team_current_account': 'Current account',
  'join_team_current_user': 'Current user',
  'join_team_verified': 'Verified',
  'join_team_verification_method': 'Verification method',
  'join_team_phone_verification': 'Phone verification',
  'join_team_email_verification': 'Email verification',
  'join_team_real_name_optional': 'Name (optional)',
  'join_team_agreement_prefix': 'I have read and agree to the',
  'join_team_joining': 'Joining...',
  'join_team_logged_in_description': 'Confirm your account to join without verifying again.',
  'join_team_verify_description': 'Verify your account to accept this team invitation.',
  'join_team_failed': 'Could not join the team. Please try again later.',
  'team_name': 'Team Name',
  'enter_team_name': 'Please enter team name',
  'industry': 'Industry',
  'company_size': 'Company Size',
  'select_company_size': 'Please select company size',
  'team_name_required': 'Please enter company name',
  'team_name_length': 'Company name length should be between 3 and 100 characters',
  'industry_required': 'Please select industry',
  'size_required': 'Please select company size',
  'size_1_10': '1-10 people',
  'size_11_50': '11-50 people',
  'size_51_100': '51-100 people',
  'size_101_300': '101-300 people',
  'size_301_1000': '301-1000 people',
  'size_1001_plus': '1001+ people',
  'team_created': 'Team created successfully!',
  'qrcode_invitation': 'QR Code Invitation',
  'link_invitation': 'Link Invitation',
  'mobile_invitation': 'Mobile Invitation',
  'mobile_phone': 'Mobile Phone',
  'enter_your_mobile_phone_number': 'Please enter mobile phone number',
  'copy': 'Copy',
  'copy_succeeded': 'Copy successful',
  'team_as_soon_as_possible3': 'Team invitation sent successfully',
  'please_fill_in_the_invitation_form': 'Please fill in the invitation form',
  'please_fill_in_the_invitation_email': 'Please fill in the invitation email',
  'please_enter_your_mobile_number': 'Please enter mobile number',
  'the_correct_mobile_phone_number': 'Please enter correct mobile phone number',
  'invitation_expiry_time': 'Invitation expiry time: ',
  'reset': 'Reset',
  'please_enter_your_real_name': 'Please enter your real name',
  'join_now': 'Join Now',
  'service_agreement': 'Service Agreement',
  'privacy_policy': 'Privacy Policy',
  'agreement_consent_text': 'By clicking Join Now, you agree that you have read and agree to the',
  'invalid_phone': 'Please enter a valid phone number',
  'team_management': 'Team Management',
  'edit_avatar': 'Edit Avatar',
  'nickname': 'Nickname',
  'modify_nickname': 'Modify Nickname',
  'phone': 'Phone',
  'rebind': 'Rebind',
  'password': 'Password',
  'reset_password': 'Reset Password',
  'crop_image': 'Crop Image',
  'crop_image_question': 'Do you need to crop the image?',
  'crop': 'Crop',
  'upload_without_crop': 'Upload without cropping',
  'upload_image': 'Upload Image',
  'cancel': 'Cancel',
  'confirm': 'Confirm',
  'verification_code': 'Verification Code',
  'next_step': 'Next Step',
  'new_password': 'New Password',
  'confirm_password': 'Confirm Password',
  'enter_new_password': 'Please enter new password',
  'confirm_new_password_again': 'Please enter new password again',
  'confirm_modification': 'Confirm Modification',
  'enter_mobile_number': 'Please enter mobile number',
  'enter_verification_code': 'Please enter verification code',
  'get_verification_code': 'Get Verification Code',
  'input_nickname': 'Please enter nickname',
  'old_phone_number': 'Old Phone Number',
  'new_phone_number': 'New Phone Number',
  'please_enter_nickname': 'Please modify your nickname',
  'save_success': 'Save successful!',
  'and': 'and',
  'image_type_error': 'Image type must be one of: .gif, jpeg, jpg, png, bmp',
  'verification_code_sent': 'SMS verification code sent successfully, please check your messages',
  'verification_code_empty': 'Phone number cannot be empty to get verification code',
  'verification_failed': 'Verification code validation failed',
  'check_account_verification': 'Please check if the account verification code is entered correctly',
  'password_reset_success': 'Password has been reset! Please log in again!',
  'enter_new_password': 'Please enter new password',
  'phone_reset_success': 'Phone has been reset! Please log in again!',
  'bind_phone_first': 'You haven\'t bound a phone yet, please bind your phone first!',
  'password_requirements': 'Must contain uppercase and lowercase letters and numbers, at least 8 characters',
  'password_confirmation': 'Please confirm password again',
  'password_mismatch': 'Please make sure both passwords match!',
  'phone_required': 'Phone number cannot be empty',
  'phone_invalid': 'Please enter a valid phone number',
  '6_digit_verification_code': 'Please enter a 6-digit verification code'
}
